module.exports = __webpack_public_path__ + "img/smart_logo_white.b1c1cde1.png";